import {RaisedButton} from "material-ui";
import {describeApprover, describeStepKind, isInfoStep, printBandLabel} from "./flow-step-form";

const React = require('react');

export const FlowStepRow = (props) => {
    const step = props.step;
    return (
        <tr>
            <td>{step.stepOrder}</td>
            <td>
                {describeStepKind(step)}
                {isInfoStep(step) && (
                    <div style={{fontSize: '12px'}}>{step.infoLabels.join(", ")}</div>
                )}
            </td>
            <td>{describeApprover(step)}</td>
            <td>{step.canEditPapers ? "DA" : "NU"}</td>
            <td>{step.canSetArticolBugetar ? "DA" : "NU"}</td>
            <td>{step.canSetRegistrationNumber ? "DA" : "NU"}</td>
            <td>{step.calling}</td>
            <td>{printBandLabel(step.printBand)}</td>
            <td>
                {
                    <div>
                        <RaisedButton
                            primary
                            label={"Edit"}
                            onClick={() => props.onEditClicked(step)}/>

                        <RaisedButton
                            secondary
                            style={{marginLeft: '10px'}}
                            label={"Delete"}
                            onClick={() => props.onDeleteClicked(step.id)}/>
                    </div>
                }
            </td>
        </tr>
    )
};
